import { ClientComment, ClientCommentTypes, CreateClientComment } from '../types/clientComment';

// CommentsController returns DTOs directly, without the usual ApiDataResponse envelope.
const requestComments = async <T>(path: string, body?: CreateClientComment): Promise<T> => {
  const response = await fetch(`/api/comments/${path}`, {
    method: body ? 'POST' : 'GET',
    headers: { Accept: 'application/json', ...(body ? { 'Content-Type': 'application/json' } : {}) },
    ...(body ? { body: JSON.stringify(body) } : {}),
  });

  if (!response.ok) {
    throw new Error(
      response.status === 401 || response.status === 403
        ? 'Нет доступа к комментариям. Проверьте авторизацию и права пользователя.'
        : 'Не удалось выполнить запрос. Попробуйте ещё раз.',
    );
  }

  return response.json();
};

export const getClientComments = (agreementId: string) =>
  requestComments<ClientComment[]>(`clientaccount/${encodeURIComponent(agreementId)}`);

export const getClientCommentTypes = () => requestComments<ClientCommentTypes>('types');

export const createClientComment = (agreementId: string, body: CreateClientComment) =>
  requestComments<ClientComment>(`clientaccount/${encodeURIComponent(agreementId)}`, body);
